import React from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { DialogContent, TextField, Grid } from '@mui/material';
import { EditDialogTitle, TableDialogActions } from '../../components/dialogComponents';

import { submitData } from '../../utils/apiHelpers';

import './formStyles.css';

// Validation Schema using Yup
const SysFormSchema = Yup.object().shape({
    section: Yup.string().required('Required'),
    key: Yup.string().required('Required'),
    value: Yup.string().required('Required'),
    type: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
});

class SysForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          id :'',
          section : '',
          key : '',
          value : '',
          type : '',
          description : '',
        }
    }
    componentDidMount() {
        if (this.props.edit && this.props.rowid) {
            this.props.api.get('/SysConfig/'+this.props.rowid)
                .then(response => {
                    const data = (response.id === this.props.rowid) && response;
                    this.setState({
                        id: data ? data.id : '',
                        section: data ? data.section : '',
                        key: data ? data.key : '',
                        value: data ? data.value : '',
                        type: data ? data.type : '',
                        description: data ? data.description : ''
                    });
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }
    }

    render() {
        const { rowid, edit, dialogClose, alert, api } = this.props;
        return (
            <Formik
                enableReinitialize
                initialValues={{
                    id: rowid ? this.state.id : '',
                    section: rowid ? this.state.section : '',
                    key: rowid ? this.state.key :'',
                    value: rowid ? this.state.value : '',
                    type: rowid ? this.state.type : '',
                    description: rowid ? this.state.description : '',
                }}
                validationSchema={SysFormSchema}
                onSubmit={(values) => {
                    const config = {
                        api: api,
                        method: edit ? 'put' : 'post',
                        endpoint: '/SysConfig/',
                        data: values, // Use Formik values here
                        onSuccess: (response) => {
                            dialogClose();
                            alert(edit ? "Configuração atualizada com sucesso." : "Configuração criada com sucesso.");
                        },
                        onError: (error) => {
                            alert('Ocorreu um erro ao ' + (edit ? 'atualizar' : 'criar') + ' a configuração.');
                        }
                    };

                    submitData(config);
                }}
            >
                {({ errors, touched, handleChange, handleBlur }) => (
                    <Form>
                        <EditDialogTitle edit={edit} />

                        <DialogContent className="formContainer">
                            <Grid container spacing = {2}>
                                <Grid item xs={12}>
                                    <Field as={TextField}
                                            className="formField"
                                            name="section"
                                            label="Section"
                                            required
                                            error={touched.section && !!errors.section}
                                            helperText={touched.section && errors.section}
                                            onChange={handleChange} onBlur={handleBlur} />
                                </Grid>

                                <Grid item xs={12}>
                                    <Field as={TextField}
                                            name="key"
                                            className="formField"
                                            label="Key"
                                            required
                                            error={touched.key && !!errors.key}
                                            helperText={touched.key && errors.key}
                                            onChange={handleChange} onBlur={handleBlur} />
                                </Grid>

                                <Grid item xs={12}>
                                    <Field as={TextField}
                                            name="value"
                                            className="formField"
                                            label="Value"
                                            required
                                            error={touched.value && !!errors.value}
                                            helperText={touched.value && errors.value}
                                            onChange={handleChange} onBlur={handleBlur}
                                            multiline />
                                </Grid>

                                <Grid item xs={12}>
                                    <Field as={TextField}
                                            name="type"
                                            className="formField"
                                            label="Type"
                                            required
                                            error={touched.type && !!errors.type}
                                            helperText={touched.type && errors.type}
                                            onChange={handleChange} onBlur={handleBlur} />
                                </Grid>

                                <Grid item xs={12}>
                                    <Field as={TextField}
                                            name="description"
                                            className="formField"
                                            label="Descrição"
                                            required
                                            error={touched.description && !!errors.description}
                                            helperText={touched.description && errors.description}
                                            onChange={handleChange} onBlur={handleBlur} />
                                </Grid>
                            </Grid>
                        </DialogContent>

                        <TableDialogActions dialogClose={dialogClose} onSave={this.handleSubmit} />
                    </Form>
                )}
            </Formik>
        );
    }
}

export default SysForm;

